
import {
  requester
} from '../utils';

export const fetchAllRoles = _ => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/role`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};